import { render, staticRenderFns } from "./AccettazioneSsnAccettazioneNreModal.vue?vue&type=template&id=01fd4c66&scoped=true"
import script from "./AccettazioneSsnAccettazioneNreModal.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnAccettazioneNreModal.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnAccettazioneNreModal.vue?vue&type=style&index=0&id=01fd4c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fd4c66",
  null
  
)

export default component.exports